import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IContent } from '../../../models';
import { UtilityBarComponent } from '@sirius/common';

@Component({
    selector: 'butterfly-utility-bar-wrapper',
    templateUrl: './utility-bar-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [UtilityBarComponent],
})
export class UtilityBarWrapperComponent {
    @Input({ required: true }) content!: IContent;
    @Input({ required: true }) culture!: string;
}
